<div
    class="d-flex flex-row flex-nowrap align-content-center justify-content-between align-items-center text-center mca-menu mx-auto px-4 px-md-4 py-2 mb-2 mb-md-4 mt-1 mt-sm-2"
>
    @for (menuItem of menuItems$ | async; track trackByMenuItem($index, menuItem)) {
        <div
            [routerLink]="[menuItem.link]"
            routerLinkActive="menu-item--active"
            class="menu-item d-flex justify-content-center align-items-center flex-column"
        >
            <div class="text-center mca-action rounded px-2">
                <p class="mb-0 menu-item-icon" [ngClass]="{ 'menu-item-alert': menuItem?.unread }">
                    <i class="las la-3x la-{{ menuItem.icon }}"></i>
                </p>
                <p class="mb-0 menu-item-name">{{ menuItem.name }}</p>
            </div>
        </div>
    }
</div>
